import {
    getSelectedCover,
    getCustomerIdValue,
    getVehicleRecordIdValue,
    getInsuranceQuotationIdValue,
} from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import { getDeclarationsForm } from '../../../selectors/ugMotorInsurance/declarations';
import { getDocumentsForm } from '../../../selectors/ugMotorInsurance/documents';

const trimBase64Prefix = (base64String) => {
    const commaIndex = base64String.indexOf(',');

    // Check if the comma is found in the base64 string
    if (commaIndex !== -1) {
        // If found, remove everything before the comma
        return base64String.substring(commaIndex + 1);
    } else {
        // If not found, return the original string
        return base64String;
    }
};

export const submitDocumentsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const state = store.getState();

                const selectedCover = getSelectedCover(state);

                let resp;

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await makeComprehensiveSubmission(state);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await makeThirdPartySubmission(state);
                }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const comprehensivePayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);
    const declarations = getDeclarationsForm(state);
    const documents = getDocumentsForm(state);

    const docsPayload = {
        insurance_id: customerId.value,
        quotation_id: insuranceQuotationId.value,
        vehicle_id: vehicleRecordId.value,
        logBook: documents.logbookUpload.value ? documents.logbookUpload.value.base64File : 'N/A',
        drivingLicense: documents.licenseUpload.value ? documents.licenseUpload.value.base64File : 'N/A',
        nationalId: documents.idUpload.value ? documents.idUpload.value.base64File : 'N/A',
        valuationReport: documents.valuationReportUpload.value
            ? documents.valuationReportUpload.value.base64File
            : 'N/A',
        proposalDeclinedBefore: declarations.declineProposal?.value === 'true' ? true : false,
        specialPremiumBefore: declarations.increasedPremiums?.value === 'true' ? true : false,
        declinedForRenewalBefore: declarations.policyRejected?.value === 'true' ? true : false,
        convictionHistory: declarations.convicted?.value === 'true' ? true : false,
        healthIssues: declarations.defectVision?.value === 'true' ? true : false,
    };

    return {
        ...docsPayload,
    };
};

const makeComprehensiveSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/documents';

        return await axios.post(url, comprehensivePayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const thirdPartyPayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);

    const documents = getDocumentsForm(state);
    const declarations = getDeclarationsForm(state);

    const docsPayload = {
        id: customerId.value,
        logBook: documents.logbookUpload.value ? documents.logbookUpload.value.base64File : 'N/A',
        drivingLicense: documents.licenseUpload.value ? documents.licenseUpload.value.base64File : 'N/A',
        nationalId: documents.idUpload.value ? documents.idUpload.value.base64File : 'N/A',
        valuationReport: documents.valuationReportUpload.value
            ? documents.valuationReportUpload.value.base64File
            : 'N/A',
        stickerCollectionPoint: 'N/A',
        proposalDeclinedBefore: declarations.declineProposal.value || false,
        specialPremiumBefore: declarations.increasedPremiums.value || false,
        declinedForRenewalBefore: declarations.policyRejected.value || false,
        convictionHistory: declarations.convicted.value || false,
        healthIssues: declarations.defectVision.value || false,
    };

    return {
        ...docsPayload,
    };
};

const makeThirdPartySubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/documents';

        return await axios.post(url, thirdPartyPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
